module.exports = __webpack_public_path__ + "img/logo.ccd8072a.png";